var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{style:(_vm.inputRootStyle),attrs:{"value":_vm.displayText,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete},on:{"input":_vm.onInput},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.onEnterNative.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }